import { NgModule } from '@angular/core';
import {NgbdScrolling} from './scrolling.directive';

@NgModule({
  imports: [],
  declarations: [NgbdScrolling],
  exports: [NgbdScrolling]
})
export class SharedModule { }
